export const productData = {
  curved_stair: {
    layoutType: 'simple',
    mainImage: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/a4d2ac80-f05c-4244-bbb6-3ed5c92a765c.webp',
    alt: 'Curved stairlift on elegant staircase',
    series: 'CURVED STAIRCASE',
    title: 'Curved Stairlifts',
    subtitle: 'Perfectly fitted for complex turns',
    description: [
      'A curved staircase is often considered the pinnacle of architectural elegance. Unlike standard stairs that rely on landings to change direction, a curved staircase maintains a continuous, sweeping arc, creating a sense of fluid motion and grandeur.',
      'Beyond their function of connecting two floors, these stairs serve as a central design focal point. They are frequently placed in entry foyers because they draw the eye upward and soften the harsh right angles often found in home construction.',
      'They are also one of the most complex types of stairs to build. The handrails, in particular, often require specialized craftsmanship—using a process called bentwood lamination—to ensure the wood follows the exact curve of the staircase without breaking.'
    ],
    imageGallery: {
      title: 'Gallery',
      images: [
        {
          url: '/images/curved/1.pic.jpg',
          alt: 'Curved stairlift installation example 1',
          label: 'Installation Example 1'
        },
        {
          url: '/images/curved/2.pic.jpg',
          alt: 'Curved stairlift installation example 2',
          label: 'Installation Example 2'
        },
        {
          url: '/images/curved/3.pic.jpg',
          alt: 'Curved stairlift installation example 3',
          label: 'Installation Example 3'
        },
        {
          url: '/images/curved/4.pic.jpg',
          alt: 'Curved stairlift installation example 4',
          label: 'Installation Example 4'
        },
        {
          url: '/images/curved/5.pic.jpg',
          alt: 'Curved stairlift installation example 5',
          label: 'Installation Example 5'
        },
        {
          url: '/images/curved/6.pic.jpg',
          alt: 'Curved stairlift installation example 6',
          label: 'Installation Example 6'
        },
        {
          url: '/images/curved/7.pic.jpg',
          alt: 'Curved stairlift installation example 7',
          label: 'Installation Example 7'
        },
        {
          url: '/images/curved/8.pic.jpg',
          alt: 'Curved stairlift installation example 8',
          label: 'Installation Example 8'
        },
        {
          url: '/images/curved/9.pic.jpg',
          alt: 'Curved stairlift installation example 9',
          label: 'Installation Example 9'
        },
        {
          url: '/images/curved/15.pic.jpg',
          alt: 'Curved stairlift installation example 10',
          label: 'Installation Example 10'
        },
        {
          url: '/images/curved/11.pic.jpg',
          alt: 'Curved stairlift installation example 11',
          label: 'Installation Example 11'
        },
        {
          url: '/images/curved/12.pic.jpg',
          alt: 'Curved stairlift installation example 12',
          label: 'Installation Example 12'
        },
        {
          url: '/images/curved/13.pic.jpg',
          alt: 'Curved stairlift installation example 13',
          label: 'Installation Example 13'
        },
        {
          url: '/images/curved/14.pic.jpg',
          alt: 'Curved stairlift installation example 14',
          label: 'Installation Example 14'
        }
      ]
    },
    additionalInfoItems: [
      { icon: 'fa-truck', title: 'Free Quotation', description: 'Expert assessment at no cost' },
      { icon: 'fa-shield-halved', title: '5-Year Warranty', description: 'Comprehensive coverage included' },
      { icon: 'fa-headset', title: '24/7 Support', description: 'Always here when you need us' }
    ]
  },
  straight_stair: {
    layoutType: 'simple',
    mainImage: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/d066306d-8e02-435c-98ce-6615545a7294.webp',
    alt: 'Straight staircase with modern design',
    series: 'STRAIGHT STAIRCASE',
    title: 'Straight Stairlifts',
    subtitle: 'Efficient and elegant straight runs',
    description: [
      'Straight staircase is the gold standard of functional design. It is the most common, cost-effective, and straightforward way to connect two levels of a building.',
      'In its simplest form, a straight staircase is a flight of stairs that travels in a single direction without any change in orientation, turns, or landings (unless the height requires a break for safety).',
      'The primary drawback of a straight staircase is the amount of linear space it requires. In homes with high ceilings, a straight flight can become quite long, sometimes requiring a landing in the middle to comply with building codes.'
    ],
    imageGallery: {
      title: 'Gallery',
      images: [
        {
          url: '/images/straight/1.jpg',
          alt: 'Straight stairlift installation example 1',
          label: 'Installation Example 1'
        },
        {
          url: '/images/straight/2.jpg',
          alt: 'Straight stairlift installation example 2',
          label: 'Installation Example 2'
        },
        {
          url: '/images/straight/3.jpg',
          alt: 'Straight stairlift installation example 3',
          label: 'Installation Example 3'
        },
        {
          url: '/images/straight/4.jpg',
          alt: 'Straight stairlift installation example 4',
          label: 'Installation Example 4'
        }
      ]
    },
    additionalInfoItems: [
      { icon: 'fa-truck', title: 'Free Quotation', description: 'Expert assessment at no cost' },
      { icon: 'fa-shield-halved', title: '5-Year Warranty', description: 'Comprehensive coverage included' },
      { icon: 'fa-headset', title: '24/7 Support', description: 'Always here when you need us' }
    ]
  },
  floating_stair: {
    layoutType: 'simple',
    mainImage: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/be9ec1dc-726d-49a6-aa4f-97b404286330.webp',
    alt: 'Floating stair architectural feature',
    series: 'FLOATING STAIR',
    title: 'Floating Stair',
    subtitle: 'A stunning architectural feature that seamlessly combines beauty and practicality',
    description: [
      'A floating staircase is a masterpiece of minimalist engineering designed to create the illusion that the treads are suspended in mid-air without any visible structural support. By removing the traditional "risers" (the vertical boards between steps) and concealing the support system, these stairs allow light to flow through a room, making spaces feel larger and more open.',
      'Floating staircases are typically constructed using a combination of materials, including steel, glass, and wood, to create a sleek and modern look. The support system is often hidden within the walls or floor, making the staircase appear to be floating above the ground.',
      'To meet safety standards without sacrificing the look, designers often use frameless glass balustrades. These provide a clear safety barrier that prevents falls while keeping the "floating" illusion intact.'
    ],
    imageGallery: {
      title: 'Gallery',
      images: [
        {
          url: '/images/floating/1.pic.jpg',
          alt: 'Floating stair installation example 1',
          label: 'Installation Example 1'
        },
        {
          url: '/images/floating/2.pic.jpg',
          alt: 'Floating stair installation example 2',
          label: 'Installation Example 2'
        },
        {
          url: '/images/floating/3.pic.jpg',
          alt: 'Floating stair installation example 3',
          label: 'Installation Example 3'
        },
        {
            url: '/images/floating/4.pic.jpg',
            alt: 'Floating stair installation example 4',
            label: 'Installation Example 4'
          },
        {
          url: '/images/floating/5.pic.jpg',
          alt: 'Floating stair installation example 5',
          label: 'Installation Example 5'
        },
        {
          url: '/images/floating/6.pic.jpg',
          alt: 'Floating stair installation example 6',
          label: 'Installation Example 6'
        },
        {
          url: '/images/floating/7.pic.jpg',
          alt: 'Floating stair installation example 7',
          label: 'Installation Example 7'
        },
        {
          url: '/images/floating/8.pic.jpg',
          alt: 'Floating stair installation example 8',
          label: 'Installation Example 8'
        },
        {
          url: '/images/floating/9.pic.jpg',
          alt: 'Floating stair installation example 9',
          label: 'Installation Example 9'
        },
        {
          url: '/images/floating/10.pic.jpg',
          alt: 'Floating stair installation example 10',
          label: 'Installation Example 10'
        },
        {
          url: '/images/floating/11.pic.jpg',
          alt: 'Floating stair installation example 11',
          label: 'Installation Example 11'
        }
      ]
    },
    additionalInfoItems: [
      { icon: 'fa-truck', title: 'Free Quotation', description: 'Expert assessment at no cost' },
      { icon: 'fa-shield-halved', title: '5-Year Warranty', description: 'Comprehensive coverage included' },
      { icon: 'fa-headset', title: '24/7 Support', description: 'Always here when you need us' }
    ]
  },
  pro_series: {
    layoutType: 'standard',
    mainImage: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/af029fcf-8fdf-4ac4-9162-961e10e9dd3d.webp',
    alt: 'Luxury residential elevator Pro Series',
    series: 'PRO SERIES',
    title: 'Quiet, intelligent and comfortable ride',
    subtitle: 'Quiet Intelligence, Comfortable Companionship',
    specifications: [
      {
        icon: 'fa-layer-group',
        label: 'Type',
        value: 'Electricity Rail System'
      },
      {
        icon: 'fa-cube',
        label: 'Material',
        value: 'Aluminum & Steel'
      },
      {
        icon: 'fa-building',
        label: 'Application',
        value: 'Residential'
      },
      {
        icon: 'fa-weight-hanging',
        label: 'Capacity',
        value: '160kg / 350lbs'
      },
      {
        icon: 'fa-palette',
        label: 'Custom Options',
        value: 'Colors, Material'
      },
      {
        icon: 'fa-certificate',
        label: 'Certification',
        value: 'EN 81-50 Certified'
      }
    ],
    description: [
      'Low standby power consumption, energy saving and environmental protection. Compact size, easy to install, improve space utilisation. Standard contactless technology, immersive enjoyment of silent elevator experience.',
    ],
    customOptionsSections: [
      {
        title: 'Interface Options',
        icon: 'fa-display',
        items: [
          {
            image: '/images/interface/1.png',
            alt: 'Elevator touchscreen control panel',
            label: 'Touchscreen Panel'
          },
          {
            image: '/images/interface/2.png',
            alt: 'Elevator button control interface',
           // label: 'Button Interface'
          },
          {
            image: '/images/interface/3.png',
            alt: 'Elevator smart control panel',
           // label: 'Smart Control'
          },
          {
            image: '/images/interface/4.png',
            alt: 'Elevator voice control interface',
           // label: 'Voice Control'
          },
          {
            image: '/images/interface/5.png',
            alt: 'Elevator voice control interface',
           // label: 'Voice Control'
          },
          {
            image: '/images/interface/6.png',
            alt: 'Elevator voice control interface',
           // label: 'Voice Control'
          },
          {
            image: '/images/interface/7.png',
            alt: 'Elevator voice control interface',
           // label: 'Voice Control'
          }
        ]
      },
      {
        title: 'Landing Door Designs',
        icon: 'fa-door-open',
        items: [
          { image: '/images/d1.png', alt: 'Landing door design option 1', label: 'Option 1' },
          { image: '/images/d2.png', alt: 'Landing door design option 2', label: 'Option 2' },
          { image: '/images/d3.png', alt: 'Landing door design option 3', label: 'Option 3' },
          { image: '/images/d4.png', alt: 'Landing door design option 4', label: 'Option 4' },
          { image: '/images/d5.png', alt: 'Landing door design option 5', label: 'Option 5' },
          { image: '/images/d6.png', alt: 'Landing door design option 6', label: 'Option 6' },
          { image: '/images/d7.png', alt: 'Landing door design option 7', label: 'Option 7' },
          { image: '/images/d8.png', alt: 'Landing door design option 8', label: 'Option 8' },
          { image: '/images/d9.png', alt: 'Landing door design option 9', label: 'Option 9' }
        ]
      },
      {
        title: 'Cabin Decoration Styles',
        icon: 'fa-paintbrush',
        items: [
          {
            image: '/images/pro/1.png',
            alt: 'Wooden panel elevator decoration',
          //  label: 'Wood Panels'
          },
          {
            image: '/images/pro/2.png',
            alt: 'Mirror finish elevator cabin',
           // label: 'Mirror Finish'
          },
          {
            image: '/images/pro/3.png',
            alt: 'Leather wall panels elevator',
           // label: 'Leather Panels'
          },
          {
            image: '/images/pro/4.png',
            alt: 'Stone texture elevator decoration',
           // label: 'Stone Texture'
          },
          {
            image: '/images/pro/5.png',
            alt: 'Metal finish elevator decoration',
           // label: 'Metal Finish'
          },
          {
            image: '/images/pro/6.png',
            alt: 'Fabric wall elevator decoration',
           // label: 'Fabric Walls'
          },
          {
            image: '/images/pro/7.png',
            alt: 'Fabric wall elevator decoration',
           // label: 'Fabric Walls'
          },
          {
            image: '/images/pro/8.png',
            alt: 'Fabric wall elevator decoration',
           // label: 'Fabric Walls'
          },
          {
            image: '/images/pro/9.png',
            alt: 'Fabric wall elevator decoration',
           // label: 'Fabric Walls'
          },
          {
            image: '/images/pro/10.png',
            alt: 'Fabric wall elevator decoration',
          //  label: 'Fabric Walls'
          },
          {
            image: '/images/pro/11.png',
            alt: 'Fabric wall elevator decoration',
           // label: 'Fabric Walls'
          },
          {
            image: '/images/pro/12.png',
            alt: 'Fabric wall elevator decoration',
          //  label: 'Fabric Walls'
          },
          {
            image: '/images/pro/13.png',
            alt: 'Fabric wall elevator decoration',
          //  label: 'Fabric Walls'
          },
          {
            image: '/images/pro/14.png',
            alt: 'Fabric wall elevator decoration',
           // label: 'Fabric Walls'
          },
          {
            image: '/images/pro/15.png',
            alt: 'Fabric wall elevator decoration',
           // label: 'Fabric Walls'
          },
          {
            image: '/images/pro/16.png',
            alt: 'Fabric wall elevator decoration',
          //  label: 'Fabric Walls'
          }
        ]
      },
      {
        title: 'Ceiling & Lighting Options',
        icon: 'fa-lightbulb',
        items: [
          { image: '/images/c1.png', alt: 'Ceiling and lighting option 1' },
          { image: '/images/c2.png', alt: 'Ceiling and lighting option 2' },
          { image: '/images/c3.png', alt: 'Ceiling and lighting option 3' },
          { image: '/images/c4.png', alt: 'Ceiling and lighting option 4' },
          { image: '/images/c5.png', alt: 'Ceiling and lighting option 5' },
          { image: '/images/c6.png', alt: 'Ceiling and lighting option 6' }
        ]
      },
      {
        title: 'Flooring Materials',
        icon: 'fa-square',
        items: [
          { image: '/images/f1.png', alt: 'Flooring material option 1', label: 'Option 1' },
          { image: '/images/f2.png', alt: 'Flooring material option 2', label: 'Option 2' },
          { image: '/images/f3.png', alt: 'Flooring material option 3', label: 'Option 3' },
          { image: '/images/f4.png', alt: 'Flooring material option 4', label: 'Option 4' },
          { image: '/images/f5.png', alt: 'Flooring material option 5', label: 'Option 5' },
          { image: '/images/f6.png', alt: 'Flooring material option 6', label: 'Option 6' }
        ]
      }
    ],
    additionalInfoItems: [
      { icon: 'fa-truck', title: 'Free Quotation', description: 'Expert assessment at no cost' },
      { icon: 'fa-shield-halved', title: '5-Year Warranty', description: 'Comprehensive coverage included' },
      { icon: 'fa-headset', title: '24/7 Support', description: 'Always here when you need us' }
    ]
  },
  panoramic_series: {
    layoutType: 'standard',
    mainImage: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/1c07fa94-1edc-4f88-9f08-378b6d7c7bb5.webp',
    alt: 'Panoramic glass elevator series',
    series: 'PANORAMIC SERIES',
    title: 'Each floor presents a different view',
    subtitle: 'A distinct vista on every level, a world of views',
    specifications: [
      {
        icon: 'fa-layer-group',
        label: 'Type',
        value: 'Panoramic Glass System'
      },
      {
        icon: 'fa-cube',
        label: 'Material',
        value: 'Glass & Steel'
      },
      {
        icon: 'fa-building',
        label: 'Application',
        value: 'Residential'
      },
      {
        icon: 'fa-weight-hanging',
        label: 'Capacity',
        value: '200kg / 440lbs'
      },
      {
        icon: 'fa-palette',
        label: 'Custom Options',
        value: 'Colors, Material'
      },
      {
        icon: 'fa-certificate',
        label: 'Certification',
        value: 'EN 81-50 Certified'
      }
    ],
    description: [
      'Low standby power consumption, energy saving and environmental protection. Compact size, easy to install, improve space utilisation. Standard contactless technology, immersive enjoyment of silent elevator experience.',
    ],
    customOptionsSections: [
      {
        title: 'Interface Options',
        icon: 'fa-display',
        items: [
            {
                image: '/images/interface/1.png',
                alt: 'Elevator touchscreen control panel',
                label: 'Touchscreen Panel'
              },
              {
                image: '/images/interface/2.png',
                alt: 'Elevator button control interface',
               // label: 'Button Interface'
              },
              {
                image: '/images/interface/3.png',
                alt: 'Elevator smart control panel',
               // label: 'Smart Control'
              },
              {
                image: '/images/interface/4.png',
                alt: 'Elevator voice control interface',
               // label: 'Voice Control'
              },
              {
                image: '/images/interface/5.png',
                alt: 'Elevator voice control interface',
               // label: 'Voice Control'
              },
              {
                image: '/images/interface/6.png',
                alt: 'Elevator voice control interface',
               // label: 'Voice Control'
              },
              {
                image: '/images/interface/7.png',
                alt: 'Elevator voice control interface',
               // label: 'Voice Control'
              }
        ]
      },
      {
        title: 'Landing Door Designs',
        icon: 'fa-door-open',
        items: [
          { image: '/images/d1.png', alt: 'Landing door design option 1', label: 'Option 1' },
          { image: '/images/d2.png', alt: 'Landing door design option 2', label: 'Option 2' },
          { image: '/images/d3.png', alt: 'Landing door design option 3', label: 'Option 3' },
          { image: '/images/d4.png', alt: 'Landing door design option 4', label: 'Option 4' },
          { image: '/images/d5.png', alt: 'Landing door design option 5', label: 'Option 5' },
          { image: '/images/d6.png', alt: 'Landing door design option 6', label: 'Option 6' },
          { image: '/images/d7.png', alt: 'Landing door design option 7', label: 'Option 7' },
          { image: '/images/d8.png', alt: 'Landing door design option 8', label: 'Option 8' },
          { image: '/images/d9.png', alt: 'Landing door design option 9', label: 'Option 9' }
        ]
      },
      {
        title: 'Cabin Decoration Styles',
        icon: 'fa-paintbrush',
        items: [
            {
                image: '/images/panoramic/1.png',
                alt: 'Elevator touchscreen control panel',
               // label: 'Touchscreen Panel'
              },
              {
                image: '/images/panoramic/2.png',
                alt: 'Elevator button control interface',
               // label: 'Button Interface'
              },
              {
                image: '/images/panoramic/3.png',
                alt: 'Elevator smart control panel',
               // label: 'Smart Control'
              },
              {
                image: '/images/panoramic/4.png',
                alt: 'Elevator voice control interface',
               // label: 'Voice Control'
              },
              {
                image: '/images/panoramic/5.png',
                alt: 'Elevator voice control interface',
               // label: 'Voice Control'
              },
              {
                image: '/images/panoramic/6.png',
                alt: 'Elevator voice control interface',
              //  label: 'Voice Control'
              },
              {
                image: '/images/panoramic/7.png',
                alt: 'Elevator voice control interface',
               // label: 'Voice Control'
              }
        ]
      },
      {
        title: 'Ceiling & Lighting Options',
        icon: 'fa-lightbulb',
        items: [
          { image: '/images/c1.png', alt: 'Ceiling and lighting option 1' },
          { image: '/images/c2.png', alt: 'Ceiling and lighting option 2' },
          { image: '/images/c3.png', alt: 'Ceiling and lighting option 3' },
          { image: '/images/c4.png', alt: 'Ceiling and lighting option 4' },
          { image: '/images/c5.png', alt: 'Ceiling and lighting option 5' },
          { image: '/images/c6.png', alt: 'Ceiling and lighting option 6' }
        ]
      },
      {
        title: 'Flooring Materials',
        icon: 'fa-square',
        items: [
          { image: '/images/f1.png', alt: 'Flooring material option 1', label: 'Option 1' },
          { image: '/images/f2.png', alt: 'Flooring material option 2', label: 'Option 2' },
          { image: '/images/f3.png', alt: 'Flooring material option 3', label: 'Option 3' },
          { image: '/images/f4.png', alt: 'Flooring material option 4', label: 'Option 4' },
          { image: '/images/f5.png', alt: 'Flooring material option 5', label: 'Option 5' },
          { image: '/images/f6.png', alt: 'Flooring material option 6', label: 'Option 6' }
        ]
      }
    ],
    additionalInfoItems: [
      { icon: 'fa-truck', title: 'Free Quotation', description: 'Expert assessment at no cost' },
      { icon: 'fa-shield-halved', title: '5-Year Warranty', description: 'Comprehensive coverage included' },
      { icon: 'fa-headset', title: '24/7 Support', description: 'Always here when you need us' }
    ]
  },
  mini_series: {
    layoutType: 'standard',
    mainImage: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/7454d717-30df-400f-9d10-25dbce20ca09.webp',
    alt: 'Mini series compact elevator',
    series: 'MINI SERIES',
    title: 'The ultimate space offers infinite possibilities',
    subtitle: 'Ultimate Space, Limitless Possibilities',
    specifications: [
      {
        icon: 'fa-layer-group',
        label: 'Type',
        value: 'Compact Rail System'
      },
      {
        icon: 'fa-cube',
        label: 'Material',
        value: 'Aluminum & Steel'
      },
      {
        icon: 'fa-building',
        label: 'Application',
        value: 'Residential'
      },
      {
        icon: 'fa-weight-hanging',
        label: 'Capacity',
        value: '140kg / 308lbs'
      },
      {
        icon: 'fa-palette',
        label: 'Custom Options',
        value: 'Colors, Material'
      },
      {
        icon: 'fa-certificate',
        label: 'Certification',
        value: 'EN 81-50 Certified'
      }
    ],
    description: [
      'Smaller main machine size. The adoption of low-power main machine, realising energy saving. The adoption of the floor plan section design makes the elevator operation more stable',
    ],
    customOptionsSections: [
      {
        title: 'Interface Options',
        icon: 'fa-display',
        items: [
            {
                image: '/images/interface/1.png',
                alt: 'Elevator touchscreen control panel',
                label: 'Touchscreen Panel'
              },
              {
                image: '/images/interface/2.png',
                alt: 'Elevator button control interface',
               // label: 'Button Interface'
              },
              {
                image: '/images/interface/3.png',
                alt: 'Elevator smart control panel',
               // label: 'Smart Control'
              },
              {
                image: '/images/interface/4.png',
                alt: 'Elevator voice control interface',
               // label: 'Voice Control'
              },
              {
                image: '/images/interface/5.png',
                alt: 'Elevator voice control interface',
               // label: 'Voice Control'
              },
              {
                image: '/images/interface/6.png',
                alt: 'Elevator voice control interface',
               // label: 'Voice Control'
              },
              {
                image: '/images/interface/7.png',
                alt: 'Elevator voice control interface',
               // label: 'Voice Control'
              }
        ]
      },
      {
        title: 'Landing Door Designs',
        icon: 'fa-door-open',
        items: [
          { image: '/images/d1.png', alt: 'Landing door design option 1', label: 'Option 1' },
          { image: '/images/d2.png', alt: 'Landing door design option 2', label: 'Option 2' },
          { image: '/images/d3.png', alt: 'Landing door design option 3', label: 'Option 3' },
          { image: '/images/d4.png', alt: 'Landing door design option 4', label: 'Option 4' },
          { image: '/images/d5.png', alt: 'Landing door design option 5', label: 'Option 5' },
          { image: '/images/d6.png', alt: 'Landing door design option 6', label: 'Option 6' },
          { image: '/images/d7.png', alt: 'Landing door design option 7', label: 'Option 7' },
          { image: '/images/d8.png', alt: 'Landing door design option 8', label: 'Option 8' },
          { image: '/images/d9.png', alt: 'Landing door design option 9', label: 'Option 9' }
        ]
      },
      {
        title: 'Cabin Decoration Styles',
        icon: 'fa-paintbrush',
        items: [
          {
            image: 'images/mini/1.png',
            alt: 'Wooden panel elevator decoration',
           // label: 'Wood Panels'
          },
          {
            image: 'images/mini/2.png',
            alt: 'Mirror finish elevator cabin',
           // label: 'Mirror Finish'
          },
          {
            image: 'images/mini/3.png',
            alt: 'Fabric wall elevator decoration',
           // label: 'Fabric Walls'
          }
        ]
      },
      {
        title: 'Ceiling & Lighting Options',
        icon: 'fa-lightbulb',
        items: [
          { image: '/images/c1.png', alt: 'Ceiling and lighting option 1' },
          { image: '/images/c2.png', alt: 'Ceiling and lighting option 2' },
          { image: '/images/c3.png', alt: 'Ceiling and lighting option 3' },
          { image: '/images/c4.png', alt: 'Ceiling and lighting option 4' },
          { image: '/images/c5.png', alt: 'Ceiling and lighting option 5' },
          { image: '/images/c6.png', alt: 'Ceiling and lighting option 6' }
        ]
      },
      {
        title: 'Flooring Materials',
        icon: 'fa-square',
        items: [
          { image: '/images/f1.png', alt: 'Flooring material option 1', label: 'Option 1' },
          { image: '/images/f2.png', alt: 'Flooring material option 2', label: 'Option 2' },
          { image: '/images/f3.png', alt: 'Flooring material option 3', label: 'Option 3' },
          { image: '/images/f4.png', alt: 'Flooring material option 4', label: 'Option 4' },
          { image: '/images/f5.png', alt: 'Flooring material option 5', label: 'Option 5' },
          { image: '/images/f6.png', alt: 'Flooring material option 6', label: 'Option 6' }
        ]
      }
    ],
    additionalInfoItems: [
      { icon: 'fa-truck', title: 'Free Quotation', description: 'Expert assessment at no cost' },
      { icon: 'fa-shield-halved', title: '5-Year Warranty', description: 'Comprehensive coverage included' },
      { icon: 'fa-headset', title: '24/7 Support', description: 'Always here when you need us' }
    ]
  },
  classies_series: {
    layoutType: 'standard',
    mainImage: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/dd9dd189-709b-4e4b-ae23-030052c6e4f6.webp',
    alt: 'Classies series elevator modernization',
    series: 'CLASSIES SERIES',
    title: 'Modernization',
    subtitle: 'Intelligence at your fingertips. Serenity in your home.',
    specifications: [
      {
        icon: 'fa-layer-group',
        label: 'Type',
        value: 'Modernization System'
      },
      {
        icon: 'fa-cube',
        label: 'Material',
        value: 'Aluminum & Steel'
      },
      {
        icon: 'fa-building',
        label: 'Application',
        value: 'Residential'
      },
      {
        icon: 'fa-weight-hanging',
        label: 'Capacity',
        value: '160kg / 350lbs'
      },
      {
        icon: 'fa-palette',
        label: 'Custom Options',
        value: 'Colors, Material'
      },
      {
        icon: 'fa-certificate',
        label: 'Certification',
        value: 'EN 81-50 Certified'
      }
    ],
    description: [
      'Old elevators have problems such as high noise, poor performance, and poor safety due to backward structure, technology, and long service life. Modernization and renovation give a new experience to building traffic with lower cost, shorter',
      'Low standby power consumption, energy saving and environmental protection. Compact size, easy to install, improve space utilisation. Standard contactless technology, immersive enjoyment of silent elevator experience.',
      'Safe and secure operation. Reliable detection accuracy, precise control. Simplified and easy to install and maintain. No need to reset the base station level during power. failure recovery, no loss of position.'
    ],
    customOptionsSections: [
      {
        title: 'Interface Options',
        icon: 'fa-display',
        items: [
            {
                image: '/images/interface/1.png',
                alt: 'Elevator touchscreen control panel',
                label: 'Touchscreen Panel'
              },
              {
                image: '/images/interface/2.png',
                alt: 'Elevator button control interface',
               // label: 'Button Interface'
              },
              {
                image: '/images/interface/3.png',
                alt: 'Elevator smart control panel',
               // label: 'Smart Control'
              },
              {
                image: '/images/interface/4.png',
                alt: 'Elevator voice control interface',
               // label: 'Voice Control'
              },
              {
                image: '/images/interface/5.png',
                alt: 'Elevator voice control interface',
               // label: 'Voice Control'
              },
              {
                image: '/images/interface/6.png',
                alt: 'Elevator voice control interface',
               // label: 'Voice Control'
              },
              {
                image: '/images/interface/7.png',
                alt: 'Elevator voice control interface',
               // label: 'Voice Control'
              }
        ]
      },
      {
        title: 'Landing Door Designs',
        icon: 'fa-door-open',
        items: [
          { image: '/images/d1.png', alt: 'Landing door design option 1', label: 'Option 1' },
          { image: '/images/d2.png', alt: 'Landing door design option 2', label: 'Option 2' },
          { image: '/images/d3.png', alt: 'Landing door design option 3', label: 'Option 3' },
          { image: '/images/d4.png', alt: 'Landing door design option 4', label: 'Option 4' },
          { image: '/images/d5.png', alt: 'Landing door design option 5', label: 'Option 5' },
          { image: '/images/d6.png', alt: 'Landing door design option 6', label: 'Option 6' },
          { image: '/images/d7.png', alt: 'Landing door design option 7', label: 'Option 7' },
          { image: '/images/d8.png', alt: 'Landing door design option 8', label: 'Option 8' },
          { image: '/images/d9.png', alt: 'Landing door design option 9', label: 'Option 9' }
        ]
      },
      {
        title: 'Cabin Decoration Styles',
        icon: 'fa-paintbrush',
        items: [
            {
                image: '/images/pro/1.png',
                alt: 'Wooden panel elevator decoration',
              //  label: 'Wood Panels'
              },
              {
                image: '/images/pro/2.png',
                alt: 'Mirror finish elevator cabin',
               // label: 'Mirror Finish'
              },
              {
                image: '/images/pro/3.png',
                alt: 'Leather wall panels elevator',
               // label: 'Leather Panels'
              },
              {
                image: '/images/pro/4.png',
                alt: 'Stone texture elevator decoration',
               // label: 'Stone Texture'
              },
              {
                image: '/images/pro/5.png',
                alt: 'Metal finish elevator decoration',
               // label: 'Metal Finish'
              },
              {
                image: '/images/pro/6.png',
                alt: 'Fabric wall elevator decoration',
               // label: 'Fabric Walls'
              },
              {
                image: '/images/pro/7.png',
                alt: 'Fabric wall elevator decoration',
               // label: 'Fabric Walls'
              },
              {
                image: '/images/pro/8.png',
                alt: 'Fabric wall elevator decoration',
               // label: 'Fabric Walls'
              },
              {
                image: '/images/pro/9.png',
                alt: 'Fabric wall elevator decoration',
               // label: 'Fabric Walls'
              },
              {
                image: '/images/pro/10.png',
                alt: 'Fabric wall elevator decoration',
              //  label: 'Fabric Walls'
              },
              {
                image: '/images/pro/11.png',
                alt: 'Fabric wall elevator decoration',
               // label: 'Fabric Walls'
              },
              {
                image: '/images/pro/12.png',
                alt: 'Fabric wall elevator decoration',
              //  label: 'Fabric Walls'
              },
              {
                image: '/images/pro/13.png',
                alt: 'Fabric wall elevator decoration',
              //  label: 'Fabric Walls'
              },
              {
                image: '/images/pro/14.png',
                alt: 'Fabric wall elevator decoration',
               // label: 'Fabric Walls'
              },
              {
                image: '/images/pro/15.png',
                alt: 'Fabric wall elevator decoration',
               // label: 'Fabric Walls'
              },
              {
                image: '/images/pro/16.png',
                alt: 'Fabric wall elevator decoration',
              //  label: 'Fabric Walls'
              }
        ]
      },
      {
        title: 'Ceiling & Lighting Options',
        icon: 'fa-lightbulb',
        items: [
          { image: '/images/c1.png', alt: 'Ceiling and lighting option 1' },
          { image: '/images/c2.png', alt: 'Ceiling and lighting option 2' },
          { image: '/images/c3.png', alt: 'Ceiling and lighting option 3' },
          { image: '/images/c4.png', alt: 'Ceiling and lighting option 4' },
          { image: '/images/c5.png', alt: 'Ceiling and lighting option 5' },
          { image: '/images/c6.png', alt: 'Ceiling and lighting option 6' }
        ]
      },
      {
        title: 'Flooring Materials',
        icon: 'fa-square',
        items: [
          { image: '/images/f1.png', alt: 'Flooring material option 1', label: 'Option 1' },
          { image: '/images/f2.png', alt: 'Flooring material option 2', label: 'Option 2' },
          { image: '/images/f3.png', alt: 'Flooring material option 3', label: 'Option 3' },
          { image: '/images/f4.png', alt: 'Flooring material option 4', label: 'Option 4' },
          { image: '/images/f5.png', alt: 'Flooring material option 5', label: 'Option 5' },
          { image: '/images/f6.png', alt: 'Flooring material option 6', label: 'Option 6' }
        ]
      }
    ],
    additionalInfoItems: [
      { icon: 'fa-truck', title: 'Free Quotation', description: 'Expert assessment at no cost' },
      { icon: 'fa-shield-halved', title: '5-Year Warranty', description: 'Comprehensive coverage included' },
      { icon: 'fa-headset', title: '24/7 Support', description: 'Always here when you need us' }
    ]
  }
};
